<template>
  <section class="unsubscriber-success">
    <div class="head">
      <h2>{{ company }}</h2>
    </div>
    <div class="info">
      <div class="success" v-if="showSuccess">
        <a-result
          status="success"
          title="Suscripción cancelada con éxito"
          :sub-title="`Tu correo “${email}” ha sido removido exitosamente de nuestra base de datos de suscriptores.`"
        >
        </a-result>
      </div>
      <div class="cancel" v-else>
        <h2>Cancelar suscripción</h2>
        <p>
          Lamentamos que desees darte de baja. Este será el correo al que se le cancelará su
          suscripción en nuestra empresa.
        </p>
        <p class="email">{{ email }}</p>
        <a-form ref="formRef" :model="formState" layout="vertical" hide-required-mark>
          <a-form-item name="comment" label="Motivo de la desuscripción (opcional)">
            <a-textarea
              v-model:value="formState.comment"
              placeholder="Escribir el mensaje inicial"
              :maxlength="maxLength"
              :rows="4"
            />
          </a-form-item>
          <div class="footer">
            <a-button type="primary" danger @click="handleOk">Cancelar suscripción</a-button>
          </div>
        </a-form>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { ref, reactive, computed } from "vue";
import { useRoute } from "vue-router";
import { emailService } from "@/app/emails/services/Email.service";
import httpManager from "@/app/shared/utils/httpManager";

const formRef = ref();
const route = useRoute();

const showSuccess = ref(false);
const email = ref("");
const company = ref("");
const strategyMessageId = ref<number | null>(null);
const maxLength = 250;

const formState = reactive({
  comment: "",
});

const query = computed(() => route.query);

if (query.value.email) {
  email.value = query.value.email as string;
}
if (query.value.company) {
  company.value = query.value.company as string;
}
if (query.value.strategy_message_id) {
  strategyMessageId.value = Number(query.value.strategy_message_id);
}

const handleOk = async () => {
  await formRef.value.validateFields();

  if (!strategyMessageId.value) return;

  const hostname = window.location.hostname;

  const workspace = hostname.split(`.${import.meta.env.VITE_HOSTNAME}`)[0];

  httpManager.updateBaseURL(`https://${workspace}.backend.${import.meta.env.VITE_HOSTNAME}`);

  console.log(`https://${workspace}.backend.${import.meta.env.VITE_HOSTNAME}`, 'updateBaseURL');
  // await emailService.unsubscribeEmailByRoute(
  //   email.value,
  //   strategyMessageId.value,
  //   formState.comment
  // );
  showSuccess.value = true;
};
</script>
<style lang="sass" scoped>
.unsubscriber-success
  height: 90vh
  display: flex
  justify-content: center
  align-items: center
  background: #F6FAFF
  .head
    background: white
    padding: 10px 50px
    position: absolute
    top: 0
    width: 100%
  .info
    display: flex
    justify-content: center
    background: #FFFFFF
    padding: 20px
    border-radius: 10px
    box-shadow: 0px 5px 12px 4px rgba(0, 0, 0, 0.09)
    .cancel
      width: 600px
      .email
        font-size: 30px
        color: #030852
        font-weight: 600
      .footer
        display: flex
        justify-content: flex-end
    .success
      width: 550px
</style>
<style>
.unsubscriber-success .ant-result-title {
  font-weight: 600;
}
</style>
